// @flow

import LngLatBounds from "../geo/lng_lat_bounds";
import { mercatorXfromLng, mercatorYfromLat } from "../geo/mercator_coordinate";

import type { CanonicalTileID } from "./tile_id";

class TileBounds {
    bounds: LngLatBounds;
    minzoom: number;
    maxzoom: number;

    constructor(
        bounds: [number, number, number, number],
        minzoom: ?number,
        maxzoom: ?number
    ) {
        this.bounds = LngLatBounds.convert(this.validateBounds(bounds));
        this.minzoom = minzoom || 0;
        this.maxzoom = maxzoom || 24;
    }

    validateBounds(bounds: [number, number, number, number]) {
        // make sure the bounds property contains valid longitude and latitudes
        if (!Array.isArray(bounds) || bounds.length !== 4)
            return [-180, -90, 180, 90];
        return [
            Math.max(-180, bounds[0]),
            Math.max(-90, bounds[1]),
            Math.min(180, bounds[2]),
            Math.min(90, bounds[3]),
        ];
    }
    // mapbox-gl-修改说明：判断瓦片交叉关系，支持自定义坐标系方式
    // 修改人：赵凯 2023年8月11日
    // mapbox-gl-修改说明：从map.js中移过来
    // 修改人：龚跃健 2024年6月18日
    contains(tileID: CanonicalTileID) {
        let level;
        const { crsParams } = tileID;
        if (crsParams) {
            const crs = tileID.getCRS();
            // 获取裁图坐标系范围
            const extent = crs.getExtent();
            // 获取坐标系范围信息
            const info = crs.getCoordsInfo(extent);
            // 设置坐标系原点
            const width = info.width;
            const height = info.height;
            const originX = info.originX; // -180
            const originY = info.originY; // 90
            const e = Math.pow(2, tileID.z);

            level = {
                minX: Math.floor(
                    ((this.bounds.getWest() - originX) * e) / width
                ),
                minY: Math.floor(
                    ((originY - this.bounds.getNorth()) * e) / height
                ),
                maxX: Math.ceil(
                    ((this.bounds.getEast() - originX) * e) / width
                ),
                maxY: Math.ceil(
                    ((originY - this.bounds.getSouth()) * e) / height
                ),
            };
        } else {
            const worldSize = Math.pow(2, tileID.z);
            level = {
                minX: Math.floor(
                    mercatorXfromLng(this.bounds.getWest()) * worldSize
                ),
                minY: Math.floor(
                    mercatorYfromLat(this.bounds.getNorth()) * worldSize
                ),
                maxX: Math.ceil(
                    mercatorXfromLng(this.bounds.getEast()) * worldSize
                ),
                maxY: Math.ceil(
                    mercatorYfromLat(this.bounds.getSouth()) * worldSize
                ),
            };
        }
        const hit =
            tileID.x >= level.minX &&
            tileID.x < level.maxX &&
            tileID.y >= level.minY &&
            tileID.y < level.maxY;
        return hit;
    }
}

export default TileBounds;
